import React from "react";
import { Plan } from "../../types/plans/plan";
import { CardHeading } from "./CardHeading";
import { PlanAccount } from "./PlanAccount";
import { StdPlanText } from "./StdPlanText";
import { UnlockPlanOrAlternative } from "./UnlockPlanOrAlternative";
import { UpsellCardBase } from "./UpsellCardBase";
import { useUpsellAnalytics } from "./useUpsellAnalytics";

export const TradingStockPlanCard = ({
  recommendedPlan,
  cheaperPlan,
  currentPlan,
  account,
}: {
  currentPlan: Plan | undefined;
  recommendedPlan: Plan;
  cheaperPlan: Plan;
  account: PlanAccount;
}) => {
  useUpsellAnalytics("traderPlan", recommendedPlan.name);

  return (
    <UpsellCardBase
      heading={
        <CardHeading>
          {currentPlan ? `Unlock Trading Stock` : "Get your tax report"}
        </CardHeading>
      }
      content={
        <StdPlanText
          recommendedPlan={recommendedPlan}
          currentPlan={currentPlan}
          account={account}
          subtext={`Download a crypto tax report with support for Trading Stock.`}
        />
      }
      actions={
        <UnlockPlanOrAlternative
          account={account}
          currentPlan={currentPlan}
          recommendedPlan={recommendedPlan}
          cheaperPlan={cheaperPlan}
        />
      }
    />
  );
};
